import { useSelector } from 'react-redux';

import Form from 'app/components/Form';
import { formatOptions } from 'app/utils/options';

import {
  getSimpleJobs
} from 'app/services/jobs';

const GuestForm = props => {
  const {
    guest,
    onClose,
    onSubmit,
    action,
    job,
    kioskOptions
  } = props;

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  const account = useSelector(state => state.portalReducer.account);

  const getJobOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    let jobs = await getSimpleJobs();
    return formatOptions(jobs);
  }

  let fields = [
    { name: 'kiosk_id', label: 'Kiosk', type: 'select', value: job?.kiosk_id, valueType: 'integer', options: kioskOptions, helperText: 'Kiosk that guest belongs to', hideNoneOption: true, disabled: true }
  ];

  // enable either single name field or first and last name.
  // hard coded to first and last name for now, but the single name field
  // can be enabled for locales or situations where its desired.
  // this can be made into an account flag.
  // for now it defaults to splitting unless this is an existing guest
  // and there's no first or last name set
  let splitNameField = !guest || guest.first_name || guest.last_name;
  if (splitNameField) {
    // note - styling would be better with flexbox, as in DateTimePicker
    let fieldStyle = {
      width: 'calc(50% - 0.5rem)',
      marginRight: '0.5rem'
    }

    fields.push({
      type: 'inline',
      fields: [
        { name: 'first_name', label: 'First Name', type: 'text', value: guest?.first_name, sx: fieldStyle, helperText: "Given name" },
        { name: 'last_name', label: 'Last Name', type: 'text', value: guest?.last_name, sx: fieldStyle, helperText: "Family name" }
      ]
    });

  } else {
    fields.push({ name: 'name', label: 'Name', type: 'text', value: guest?.name, helperText: "Full name" });
  }

  fields.push({ name: 'email', label: 'Email', type: 'text', value: guest?.email, helperText: "Email address" });

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default GuestForm;
